import { useSnackbar, VariantType } from 'notistack';
import * as React from 'react';

type SnackbarRef = ReturnType<typeof useSnackbar>;

interface IProps {
  setUseSnackbarRef: (showSnackbar: SnackbarRef) => void;
}

const InnerSnackbarUtilsConfigurator: React.FC<IProps> = (props: IProps) => {
  props.setUseSnackbarRef(useSnackbar());
  return null;
};

let useSnackbarRef: SnackbarRef;
const setUseSnackbarRef = (useSnackbarRefProp: SnackbarRef) => {
  useSnackbarRef = useSnackbarRefProp;
};

export const SnackbarUtilsConfigurator = () => {
  return <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRef} />;
};

const SnackbarUtil = {
  success(msg: string) {
    this.toast(msg, 'success');
  },
  warning(msg: string) {
    this.toast(msg, 'warning');
  },
  info(msg: string) {
    this.toast(msg, 'info');
  },
  error(msg: string) {
    this.toast(msg, 'error');
  },
  toast(msg: string, variant: VariantType = 'default') {
    useSnackbarRef.enqueueSnackbar(msg, { variant });
  },
};

export default SnackbarUtil;
